import { Base, createApp, importWhenVisible } from '@studiometa/js-toolkit';
import SliderCollection from './molecules/SliderCollection';
import { Action, LargeText, ScrollAnimationParent, Modal, Tabs, DataBind, DataModel, DataEffect } from '@studiometa/ui';
import MenuGroup from './molecules/Menu/MenuGroup.js';
import Menu from './molecules/Menu/Menu.js';
import Slider from './molecules/Slider.js';
import SliderProduct from './molecules/SliderProduct.js';
import Search from './organisms/Search/index.js';
import HeaderSearch from './organisms/HeaderSearch/index.js';
import LocalSwitcher from './molecules/LocalSwitcher.js';
import Reassurance from './molecules/Reassurance.js';
import SliderTabs from './molecules/SliderTab.js';
import VariantDropdown from './molecules/VariantDropdown.js';

/**
 * App
 */
class App extends Base {
  /**
   * App Configuration
   */
  static config = {
    name: 'App',
    components: {
      Slider,
      DataEffect,
      DataBind,
      DataModel,
      ScrollAnimationParent,
      SliderCollection,
      SliderProduct,
      SliderTabs,
      Action,
      Search,
      HeaderSearch,
      LargeText,
      LocalSwitcher,
      Reassurance,
      Weather: (app) => importWhenVisible(
        () => import('./organisms/Weather/index.js'),
        'Weather',
        app
      ),
      VariantDropdown,
      Tabs,
      Modal,
      MenuGroup,
      Menu,
      FullHeightProduct: (app) => importWhenVisible(
          () => import('./organisms/FullHeightProduct.js'),
          'FullHeightProduct',
          app
        ),
      BirthdayForm: (app) => importWhenVisible(
        () => import('./molecules/BirthdayForm.js'),
        'BirthdayForm',
        app
      )
    },
    log: true,
  };

  mounted() {
    this.$log('mounted');
  }

  onHeaderSearchShowSearch() {
    this.$children.Search[0].open();
  }
}

export default createApp(App, document.body);
